export default "/images/719481f9cafd3ac31f55c00a2e7d7c5c.avif";